import React, { useState, useEffect, useContext, useRef } from 'react';
import { FaPrint } from 'react-icons/fa';
import filetextcigna from "../assets/images/icons/file-text.svg";
import arrowleft from '../assets/images/icons/arrow-left.svg';
import printergrey from "../assets/images/icons/printer-grey.svg";
import vectorarrow from "../assets/images/icons/Vector-Arrow.svg";
import "../styles/billingSummaryPage.css";
import "../assets/css/feather.css";
import Billing from './billing';
import { BillingSummaryContext } from '../contexts/BillingSummaryContext';
import { format } from "date-fns";
import { getApiService } from '../services/ApiService';
import { Modal, ProgressBar, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { GetPayLoad } from '../services/PayLoadStorage';
import { useReactToPrint } from "react-to-print";
import { LanguageContext } from "../contexts/LanguageContext";
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';

const BillingSummary = (props) => {
  const navigate = useNavigate();
  const { billSummaryKeyValue, setBillSummaryKeyValue } = useContext(BillingSummaryContext);
  const [billSummaryData, setBillSummaryData] = useState([]);
  const [billingFees, setBillingFees] = useState([]);
  const [coverageSummary, setCoverageSummary] = useState([]);
  const [paymentsRecvd, setPaymentsRecvd] = useState([]);
  const [billingAdjustments, setBillingAdjustments] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isViewMyBillLoading, setIsViewMyBillLoading] = useState(true);
  const [caseInfo, setCaseInfo] = useState([]);
  const Payload = GetPayLoad('PayLoad');
  /* PMO0004087 CHG0127827 SD47534 */
  const showSTPS3 = Cookies.get('showSTPS3') !== 'false';
  const contentRef = useRef();
  const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
  const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed
  const reactToPrintFn = useReactToPrint({ contentRef });
  const currentLang = Cookies.get('lang') || 'eng';
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const headers = {
    "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
    "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
    "X-Hps-Region": Payload?.region,
    "X-Hps-Carrier": Payload?.owning_carrier
  };

  const { pageContent } = useContext(LanguageContext);
  const [billingContent, setBillingContent] = useState([]);
  const [genericContent, setGenericContent] = useState([]);

  useEffect(() => {
    // Set billing and generic content based on the current language
    let page_name = 'billing-summary';
    setBillingContent(pageContent?.[page_name]  || {});
    setGenericContent(pageContent?.generic || {});
  }, [pageContent]);

  useEffect(() => {
    //If context value is clear, get from local storage
    if (!!billSummaryKeyValue === false && localStorage.getItem('billSummaryKeyValue')) {
      const decoadeKeyValue = JSON.parse(atob(localStorage.getItem('billSummaryKeyValue')));
      setBillSummaryKeyValue(decoadeKeyValue);
    }

  }, []);

  useEffect(() => {
    //Initaite local stoarge 
    if (!localStorage.getItem('billSummaryKeyValue')) {
      localStorage.setItem('billSummaryKeyValue', btoa(JSON.stringify(billSummaryKeyValue)));
    }
  }, [billSummaryKeyValue]);

  

  useEffect(() => {
    setLoading(true);
    setIsViewMyBillLoading(true);

    //Billing Summary Details View
    const targetBillSummaryUrl = process.env.REACT_APP_API_BILLING_SUMMARY_ENDPOINT;
    getApiService(baseUrl, targetBillSummaryUrl,
      {
        cim: Payload?.cim,
        case_num: Payload?.case_num,
        period: billSummaryKeyValue.bill_per_beg_dt,
        run_date: billSummaryKeyValue.bill_run_dt,
        run_num: billSummaryKeyValue.run_number
      },
      headers
    )
      .then((response) => {
        if (response?.data && response?.data?.status == 'SUCCESS') {
          setBillSummaryData(response.data.data.billingSummary);
          setPaymentsRecvd(response.data.data.paymentsRecvd);
          setBillingAdjustments(response.data.data.billingAdjustments);
          setBillingFees(response.data.data.billingFees);
          setCoverageSummary(response.data.data.coverageSummary);
          setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed 
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });

    //Fetch profile information
    const targetCaseUrl = process.env.REACT_APP_API_CASE_INFO_ENDPOINT;
    getApiService(baseUrl, targetCaseUrl, { cim: Payload?.cim }, headers)
      .then((response) => {
        if (response?.data && response?.data?.status == 'SUCCESS') {
          const result = response.data.data;
          setCaseInfo(response.data.data);
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });

    //INC0288296 Load view my bill documents in member comm api when user lands on billing summary page
    loadViewMyBillDocs();

  }, []);
  /*st48236 - 508 compliance*/      
  // Mark content as ready
       const [userInteracted, setUserInteracted] = useState(false);
            
            useEffect(() => {
              const handleUserInteraction = () => {
                setUserInteracted(true);
              };
            
              // Listen for user interactions
              document.addEventListener('click', handleUserInteraction);
              document.addEventListener('keydown', handleUserInteraction);
              
              return () => {
                document.removeEventListener('click', handleUserInteraction);
                document.removeEventListener('keydown', handleUserInteraction);
              };
            }, []);
            
            useEffect(() => {
              let timeoutId;
              
              if (apiCallsCompleted && !isContentReady) {
                timeoutId = setTimeout(() => {
                  setContentReady(true);
                  
                  // Only auto-focus if user hasn't interacted
                  if (!userInteracted && contentRef.current) {
                    requestAnimationFrame(() => {
                      contentRef.current.focus({ preventScroll: true });
                    });
                  }
                }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
              }
              
              return () => {
                if (timeoutId) clearTimeout(timeoutId);
              };
            }, [apiCallsCompleted, isContentReady, userInteracted]);
  /*st48236 - 508 compliance*/
 
  const billingCard = [
    { name: billingContent?.billing_details_begin_date ? billingContent?.billing_details_begin_date : 'Bill Period Begin Date', value: billSummaryKeyValue && billSummaryKeyValue?.bill_per_beg_dt_format },
    { name: billingContent?.billing_details_bill_run_number ? billingContent?.billing_details_bill_run_number :'Bill Run Number', value: billSummaryKeyValue && billSummaryKeyValue?.run_number },
    { name: billingContent?.billing_details_bill_run_date ? billingContent?.billing_details_bill_run_date : 'Bill Run Date', value: billSummaryKeyValue && billSummaryKeyValue?.bill_run_dt_format },
    { name: billingContent?.billing_details_payment_deadline ? billingContent?.billing_details_payment_deadline : 'Payment Deadline', value: billSummaryKeyValue && billSummaryKeyValue?.bill_per_end_dt_format },
  ];
  //Set Negative APTC Amount if subsidy_premium is greater than 0, else set it to 0
  const aptcAmount = billSummaryKeyValue?.subsidy_premium && billSummaryKeyValue.subsidy_premium !== '$0.00' ? '-' + billSummaryKeyValue.subsidy_premium : '$0.00';
  const overView = [
    { name: billingContent?.billing_billing_history_prior_balance_text ? billingContent?.billing_billing_history_prior_balance_text : 'Prior Balance', value: billSummaryData?.[0]?.bill_prior_balance },
    { name: billingContent?.billing_details_premium_collected ? billingContent?.billing_details_premium_collected : 'Premium Collected', value: billSummaryData?.[0]?.total_premium_collected },
    { name: billingContent?.billing_details_past_due_amount ? billingContent?.billing_details_past_due_amount : 'Past Due Amount', value: billSummaryData?.[0]?.total_past_due_amount },
    { name: billingContent?.billing_details_current_charges ? billingContent?.billing_details_current_charges : 'Current Charges', value: billSummaryData?.[0]?.total_current_charges },
  ];
  if (Cookies.get('showAPTC') !== 'false') {
      overView.push({ name: billingContent?.billing_details_aptc_amount ? billingContent?.billing_details_aptc_amount : 'APTC Amount', value: aptcAmount });
  }
  if (Cookies.get('showSTPS') !== 'false') {
    const stpsAmount = billSummaryKeyValue?.state_subsidy_premium && billSummaryKeyValue.state_subsidy_premium !== '$0.00' ? '-' + billSummaryKeyValue.state_subsidy_premium : '$0.00';
    overView.push({ name: billingContent?.billing_billing_history_stps1_text ? billingContent?.billing_billing_history_stps1_text : 'STPS Amount', value: stpsAmount }); 
    }
  
    if (Cookies.get('showSTPS2') !== 'false') {
      const stps2Amount = billSummaryKeyValue?.state_subsidy2_premium && billSummaryKeyValue.state_subsidy2_premium !== '$0.00' ? '-' + billSummaryKeyValue.state_subsidy2_premium : '$0.00';
    overView.push({ name: billingContent?.billing_billing_history_stps2_text ? billingContent?.billing_billing_history_stps2_text : 'STPS 2 Amount', value: stps2Amount }); 
    }

    if (showSTPS3) { /* PMO0004087 CHG0127827 SD47534*/
      const stps3Amount = billSummaryKeyValue?.state_subsidy3_premium && billSummaryKeyValue.state_subsidy3_premium !== '$0.00' ? '-' + billSummaryKeyValue.state_subsidy3_premium : '$0.00';
      overView.push({ name: billingContent?.billing_billing_history_stps3_text ? billingContent?.billing_billing_history_stps3_text : 'STPS3 Amount', value: stps3Amount });
    }

    overView.push({ name: billingContent?.billing_details_adjustments ? billingContent?.billing_details_adjustments : 'Adjustments', value: billSummaryData?.[0]?.total_adjustments });
    overView.push({ name: billingContent?.billing_details_fees ? billingContent?.billing_details_fees : 'Fees', value: billSummaryKeyValue?.current_fees });
    overView.push({ name: billingContent?.billing_details_totaldueamt ? billingContent?.billing_details_totaldueamt : 'Total Due Amount', value: billSummaryData?.[0]?.bill_total_amount_due });


  const handelDownloadPDF = (format='pdf') => {
    const downloadFormat = format;
    const displayFlag = 1;
    const targetCaseUrl = baseUrl+process.env.REACT_APP_API_PDF_EXCEL_DOWNLOAD_ENDPOINT;

    // Create a form element
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = targetCaseUrl;
    form.target = '_blank'; // Open in a new tab or window

    // Add form fields
    const fields = {
      cim: Payload?.cim,
      region: Payload?.region,
      case_num: Payload?.case_num,
      owningCarrier: Payload?.owning_carrier,
      downloadFormat: downloadFormat,
      language: currentLang,
      sitecd: Payload?.site_cd,
      displayFlag: displayFlag,
      caseInfo: JSON.stringify(caseInfo),
      billSummary: JSON.stringify(billSummaryKeyValue),
      billSummaryData: JSON.stringify(billSummaryData),
      billingFees: JSON.stringify(billingFees),
      coverageSummary: JSON.stringify(coverageSummary),
      paymentsRecvd: JSON.stringify(paymentsRecvd),
      billingAdjustments: JSON.stringify(billingAdjustments),
      isSTPSAvailable: Cookies.get('showSTPS') !== 'false' ? true : false,
      isSTPS2Available: Cookies.get('showSTPS2') !== 'false' ? true : false,
      /* PMO0004087 CHG0127827 SD47534 */
      isSTPS3Available: Cookies.get('showSTPS3') !== 'false' ? true : false,
      isAPTCAvailable: Cookies.get('showAPTC') !== 'false' ? true : false,
      pageName: 'billingsummary',
      state: Payload?.state || null,
      "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
      "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
      "X-Hps-Region": Payload?.region,
      "X-Hps-Carrier": Payload?.owning_carrier
    };

    for (const key in fields) {
      if (fields[key] !== undefined) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = fields[key];
        form.appendChild(input);
      }
    }

    // Append the form to the body, submit it, and remove it
    document.body.appendChild(form);
    form.submit();
    if(downloadFormat === 'excel') {
      const message = genericContent?.excel_download_sucess || 'Excel Downloaded Successfully';
      toast.success(message);
    }
    document.body.removeChild(form);
  };  

  const handleBack = () => {
    //Set Cookie to view billing history modal in Billing Page
    Cookies.set('viewBillHistory', 'true', getCookieOptions());
    navigate("/billing");
  }
  
  // INC0288296 View My Bill Action
  const [showViewMyBillBtn, setShowViewMyBillBtn] = useState(false);
  const [docInfo, setDocInfo] = useState(null);
 
  const loadViewMyBillDocs = () => {
    const targetUrl = process.env.REACT_APP_VIEW_MY_BILL_ENDPOINT ?? 'v1/billing/viewmybill';
    return getApiService(baseUrl, targetUrl,
      { cim: Payload?.cim, 
        case_num: Payload?.case_num, 
        carrier_code: Payload?.owning_carrier, 
        bill_period: billSummaryKeyValue?.bill_per_beg_dt,
        site_cd: Payload?.site_cd
      },
      headers
    ).then((response) => {
        const result = response?.data?.data;
        if (result?.status === true && result?.file) {
          setShowViewMyBillBtn(true); // show button if file is available
          setDocInfo(result);
        }
      })
      .catch(error => {
        console.error('Error fetching vendor file URL:', error);
      })
      .finally(() => {
        setIsViewMyBillLoading(false);
        setLoading(false);
      });
  }

  //Open PDF File.
  const handleViewMyBillPDF = (url, docName, task) => {
		const targetEDeliveryURl = baseUrl + process.env.REACT_APP_API_EDELIVERY_PDF_ENDPOINT;
		const form = document.createElement('form');
		form.method = 'POST';
		form.action = targetEDeliveryURl;
		form.target = '_blank'; // Open in a new tab
    
		const fields = {
			pdfurl: url,
			docname: docName,
			doc_type: 'bill',
      task: task,
			"X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
			"X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
			"X-Hps-Region": Payload?.region,
			"X-Hps-Site-Id": Payload?.site_cd,
		};
		for (const key in fields) {
			if (fields[key] !== undefined) {
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = key;
				input.value = fields[key];
				form.appendChild(input);
			}
		}

		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form); // Clean up the form after submission
	};

  if (isLoading || isViewMyBillLoading) {
    return (
      <>
        <Modal
          show={isLoading}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', margin: 'inherit' }}>
              <Spinner animation="border" role="status" ></Spinner>
              <div>{genericContent?.loading_message}</div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }

  

  return (
    <>
    <main
        role="main"
        tabIndex="-1" // Make the <main> tag focusable
        ref={contentRef} // Attach the ref to the <main> tag
        style={{ outline: 'none' }} // revmove border
        aria-label="Billing Summary"
    >
      <div className="conatiner-fluid content-inner mt-n5 py-0">
        <div className="row">
          <div className="col-md-12 col-xl-12">
            <div className="row">
              <div className="col-md-12">
                <div className="card" data-aos="fade-up" data-aos-delay="800">
                  <div className="col-md-12 col-xl-12">
                    <div className="row">
                      <div className="" data-aos="fade-up" data-aos-delay="800">
                        <div className="card-body mt-3 mb-4">
                          <div className="col-12 d-xl-flex d-md-flex d-sm-flex d-block">
                            <div className="col-xl-8" tabIndex={0}>
                              <h3>{billingContent?.billing_details_billing_summary_title ? billingContent?.billing_details_billing_summary_title : 'Billing Summary'}</h3>
                            </div>
                            <div className="col-xl-4 d-none">
                              <button type="button"  onClick={reactToPrintFn}
                                className="me-3 btn btn-outline-secondary btn-lg col-12 fw-semibold">
                                {Payload?.owning_carrier !== 'Q5' && (
                                  <i className="fe fe-printer text-end ms-2 me-1 fe-22 align-middle"></i>
                                )}
                                Print
                              </button>
                            </div>
                          </div>

                          {/* Member Card */}
                          <div className="d-xl-flex mb-4 biling-details d-block col-12">
                            <div className="col-xl-7 d-xl-flex d-md-flex ">
                              <div className="col-xl-3">
                                <div className={Payload?.owning_carrier === 'Q5'?"align-items-center avatar-100":"avatar-20 mt-3 text-center"}>
                                  {Payload?.owning_carrier === 'Q5' ? (
                                    caseInfo?.profileName
                                  ) : (
                                    <h1>{caseInfo?.profileName}</h1>
                                  )}
                                </div>
                              </div>
                              <div className="col-xl-8 ms-xl-4 ms-md-4 ms-2 mt-4" tabIndex={0}>

                                <div className="col-12">
                                  <h5>{caseInfo?.displayName}</h5>
                                </div>

                                <div className="col-12">
                                  <span>Member ID {caseInfo?.carrierSubId}</span>
                                </div>

                                <div className="col-12">
                                  <span>
                                    {caseInfo?.mailAddress}
                                  </span>
                                </div>

                                <div className="col-12">
                                  <span>
                                    {caseInfo?.phoneNumber} | {caseInfo?.email}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-5 d-xl-flex d-md-flex">
                              <div className="col-xl-4 mt-3" tabIndex={0}>
                                <div
                                  className="billing-amnt text-center py-2 px-2 d-inline-block">
                                  <span className="fw-semibold">#{billSummaryKeyValue && billSummaryKeyValue?.bill_per_beg_dt_format}</span>
                                </div>

                                <div className="mt-3">
                                  <span>{billingContent?.billing_payment_returned_payments_total_amount ? billingContent?.billing_payment_returned_payments_total_amount : "Total Amount"}</span>
                                  <h3 className="fw-semibold">{billSummaryData?.[0]?.bill_total_amount_due}</h3>
                                </div>
                              </div>
                              <div className="col-xl-8">
                                <div className="card mt-4">
                                  <div
                                    className="card-body btn-download py-4 position-relative">
                                    {showViewMyBillBtn &&(
                                      <button type="button"
                                        className={Payload?.owning_carrier === 'Q5' ? "position-relative me-3 btn btn-primary btn-lg col-12 mt-2" : "position-relative me-3 btn btn-success btn-lg pdf-btn col-12 mt-2"}
                                        onClick={() => handleViewMyBillPDF(docInfo?.file, docInfo?.file_name, docInfo?.source)}
                                        >
                                          {billingContent?.billing_billdetail_view_my_bill ? billingContent?.billing_billdetail_view_my_bill : "View My Bill"}
                                        {Payload?.owning_carrier !== 'Q5' &&
                                        <img className="text-end position-absolute top-20 right-20" src={vectorarrow} alt="Download" /> }
                                      </button>
                                      )}
                                    <button type="button"
                                      className={Payload?.owning_carrier === 'Q5' ? "position-relative me-3 btn btn-primary btn-lg col-12 mt-2" : "position-relative me-3 btn btn-success btn-lg pdf-btn col-12 mt-2"}
                                      onClick={() => handelDownloadPDF('pdf')}>
                                      PDF {billingContent?.billing_billdetail_export_pdf_hint ? billingContent?.billing_billdetail_export_pdf_hint : "Download"}
                                      {Payload?.owning_carrier === 'Q5' ? (
                                        <i className="fe fe-download ms-2"></i>
                                      ) : (
                                        <img className="text-end position-absolute top-20 right-20"
                                          src={vectorarrow}
                                          alt="Download" />
                                      )}
                                    </button>
                                    <button type="button"
                                      className={Payload?.owning_carrier === 'Q5' ? "position-relative me-3 btn btn-primary btn-lg col-12 mt-2" : "position-relative me-3 btn btn-success btn-lg pdf-btn col-12 mt-2"}
                                      onClick={() => handelDownloadPDF('excel')}>
                                      Excel {billingContent?.billing_billdetail_export_pdf_hint ? billingContent?.billing_billdetail_export_pdf_hint : "Download"}
                                      {Payload?.owning_carrier === 'Q5' ? (
                                        <i className="fe fe-download ms-2"></i>
                                      ) : (
                                        <img className="text-end position-absolute top-20 right-20"
                                          src={vectorarrow}
                                          alt="Download" />
                                      )}
                                    </button>
                                  </div> 
                                </div>
                              </div>
                            </div>
                          </div>
                          <div ref={contentRef} id="d-main" className="roundedcard doc-edev">
                            <div className="d-xl-flex d-md-flex d-block col-12 mb-4" tabIndex={0}>
                              <div className="col-xl-3 px-3 py-3 rounded-4"
                                style={{ backgroundColor: '#FAFAFA' }}>
                                <div className="mb-3">
                                  {billingCard.map((item, index) => (
                                    <div className="mb-3">
                                      <h5 key={index} className="d-block">
                                        <span className="d-block fw-light mb-2">{item.name}</span>
                                        {item.value}
                                      </h5>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              <div className="col-xl-9">
                                <div className="bd-example table-responsive mt-2 table-edev">
                                  <table className={`table table-billing billing-overview ${Payload?.owning_carrier === 'Q5' ? 'no-background' : ''}`}>
                                    <thead>
                                      <tr>
                                        <th scope="col" className="fw-semibold">{billingContent?.billing_widget_billingsummary_overview ? billingContent?.billing_widget_billingsummary_overview : "Overview"} - {billSummaryKeyValue && billSummaryKeyValue?.bill_per_beg_dt_format}</th>
                                        <th scope="col" className="fw-semibold text-end">{billingContent?.billing_sections_history_table_header_bills_totals ? billingContent?.billing_sections_history_table_header_bills_totals : "Bills Total"}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {overView.map((item, index) => (
                                        <tr key={index} className="overview">
                                          <td>{item.name}</td>
                                          <td className="text-end">{item.value}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>

                            </div>

                            <div className="col-12 mb-4 border-bottom" tabIndex={0}>
                              <div className="d-flex flex-wrap align-items-baseline gap-1 mb-3">
                                <h5 className="fw-semibold mb-0">{billingContent?.billing_sections_history_table_header_payments_received ? billingContent?.billing_sections_history_table_header_payments_received : "Payment Received"}</h5>
                                <span className="fw-light">{billingContent?.billing_sections_history_table_header_payments_received_text ? billingContent?.billing_sections_history_table_header_payments_received_text : "Collected Premiums for this Bill Period"}</span>
                              </div>

                              <div className="bd-example table-responsive mt-2 table-edev">
                                <table className="table table-striped payment-received-table">
                                  <thead>
                                    <tr>
                                      <th scope="col">{billingContent?.billing_widget_receivedpayments_payment_type ? billingContent?.billing_widget_receivedpayments_payment_type : "Payment Type"}</th>
                                      <th scope="col">{billingContent?.billing_widget_receivedpayments_payment_date ? billingContent?.billing_widget_receivedpayments_payment_date : "Payment Date"}</th>
                                      <th scope="col">{billingContent?.billing_widget_billingchanges_period_applied ? billingContent?.billing_widget_billingchanges_period_applied : "Bill Period Applied"}</th>
                                      <th scope="col">{billingContent?.billing_widget_receivedpayments_confirmation_number ? billingContent?.billing_widget_receivedpayments_confirmation_number : "Confirmation No."}</th>
                                      <th scope="col">{billingContent?.billing_widget_receivedpayments_payment_amount ? billingContent?.billing_widget_receivedpayments_payment_amount : "Payment Amount"}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {paymentsRecvd?.length == 0 ? (
                                      <tr>
                                        <td colSpan={5} className="fw-semibold no-data-message">{billingContent?.billing_payment_auth_nodata_text ? billingContent?.billing_payment_auth_nodata_text : "No data found"} </td>
                                      </tr>
                                    ) : (
                                      paymentsRecvd?.map((item, index) => (
                                        <tr key={index}>
                                          <td>{(item.type === 'EFT via Web' && Cookies.get('owningCarrier') === 'Q5') ? billingContent?.billing_widget_payment_type_eft_txt : item.type}</td>
                                          <td>{item.event_date}</td>
                                          <td>{item.bill_period_applied}</td>
                                          <td>{item.conf_num}</td>
                                          <td className="text-end">{item.amount}</td>
                                        </tr>
                                      )))}
                                  </tbody>
                                </table>
                                {paymentsRecvd?.length > 0 &&
                                  <div className="text-end py-3 border-top">
                                    <h5>{billingContent?.billing_widget_receivedpayments_total_payments ? billingContent?.billing_widget_receivedpayments_total_payments : "Total Payments"}
                                      <span className="ms-4">{paymentsRecvd?.[0]?.total_rcvd_payment}</span>
                                    </h5>
                                  </div>
                                }
                              </div>
                            </div>
                            <div className="col-12 mb-4 border-bottom" tabIndex={0}>

                              <div className="d-flex flex-wrap align-items-baseline gap-1 mb-3">
                                <h5 className="fw-semibold mb-0">{billingContent?.billing_widget_billingchanges_title ? billingContent?.billing_widget_billingchanges_title : "Billing Adjustments"}</h5>
                                <span className="fw-light">{billingContent?.billing_details_sections_adjustments_table_heading_description ? billingContent?.billing_details_sections_adjustments_table_heading_description : "Changes Since Your Last Bill was generated"}</span>
                              </div>

                              <div className="bd-example table-responsive mt-2 table-edev">
                                <table className="table table-striped billing-adjustments-table">
                                  <thead>
                                    <tr>
                                      <th scope="col">{billingContent?.billing_details_sections_adjustments_table_header_description ? billingContent?.billing_details_sections_adjustments_table_header_description : "Description"}</th>
                                      <th scope="col">{billingContent?.billing_details_sections_adjustments_table_header_for_period ? billingContent?.billing_details_sections_adjustments_table_header_for_period : "For Period"}</th>
                                      <th scope="col">{billingContent?.billing_details_sections_adjustments_table_header_adjustment_amount ? billingContent?.billing_details_sections_adjustments_table_header_adjustment_amount : "Adjustment Amount"}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {billingAdjustments?.length == 0 ? (
                                      <tr>
                                        <td className="fw-semibold no-data-message">{billingContent?.billing_payment_auth_nodata_text ? billingContent?.billing_payment_auth_nodata_text : "No data found"}</td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                    ) : (
                                      billingAdjustments?.map((item, index) => (
                                        <tr key={index}>
                                          <td>{item.adjustment_desc}</td>
                                          <td>{item.period_applied}</td>
                                          <td>{item.adjustment_amount}</td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                                {billingAdjustments?.length > 0 &&
                                <div className="text-end py-3 border-top">
                                  <h5>{billingContent?.billing_details_sections_adjustments_total_adjustments ? billingContent?.billing_details_sections_adjustments_total_adjustments : "Total Adjustments"}
                                    <span className="ms-4">{billingAdjustments?.[0]?.total_adjustments}</span>
                                  </h5>
                                </div>
                                }          
                              </div>

                            </div>

                            <div className="col-12 mb-4 border-bottom" tabIndex={0}>

                              <div className="d-flex flex-wrap align-items-baseline gap-1 mb-3">
                                <h5 className="fw-semibold mb-0">{billingContent?.billing_widget_billfees_title ? billingContent?.billing_widget_billfees_title : "Billing Fees"}</h5>
                                <span className="fw-light">{billingContent?.billing_details_sections_fees_table_heading_description ? billingContent?.billing_details_sections_fees_table_heading_description : "Additional Charges Placed on Your Account"}</span>
                              </div>

                              <div className="bd-example table-responsive mt-2 table-edev">
                                <table className="table table-striped billing-fees-table">
                                  <thead>
                                    <tr>
                                      <th scope="col">{billingContent?.billing_details_sections_fees_table_header_fee_description ? billingContent?.billing_details_sections_fees_table_header_fee_description : "Fee Description"}</th>
                                      <th scope="col">{billingContent?.billing_details_sections_fees_table_header_amount_charged ? billingContent?.billing_details_sections_fees_table_header_amount_charged : "Amount Charged"}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {billingFees.length == 0 ? (
                                      <tr>
                                        <td className="fw-semibold no-data-message">{billingContent?.billing_payment_auth_nodata_text ? billingContent?.billing_payment_auth_nodata_text : "No data found"}</td>
                                        <td></td>

                                      </tr>
                                    ) : (
                                      billingFees?.map((item, index) => (
                                        <tr key={index}>
                                          <td>{item.fee_description}</td>
                                          <td>{item.current_fees}</td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                                {billingFees?.length > 0 &&
                                <div className="text-end py-3 border-top">
                                  <h5>{billingContent?.billing_details_sections_summary_table_header_total_fees ? billingContent?.billing_details_sections_summary_table_header_total_fees : "Total Fees"}
                                    <span className="ms-4">{billingFees?.[0]?.total_fees}</span>
                                  </h5>
                                </div> 
                                }
                                      
                              </div>

                            </div>

                            <div className="col-12" tabIndex={0}>

                              <div className="d-flex flex-wrap align-items-baseline gap-1 mb-3">
                                <h5 className="fw-semibold mb-0">{billingContent?.billing_details_sections_coverage_table_heading_coverage_summary ? billingContent?.billing_details_sections_coverage_table_heading_coverage_summary : "Coverage Summary"}</h5>
                                <span className="fw-light">{billingContent?.billing_details_sections_coverage_table_heading_coverage_text ? billingContent?.billing_details_sections_coverage_table_heading_coverage_text : "Your subscribed Products and Monthly Charges"}</span>
                              </div>

                              <div className="bd-example table-responsive mt-2 table-edev">
                                <table className="table table-striped coverage-summary-table">
                                  <thead>
                                    <tr>
                                      <th scope="col">{billingContent?.billing_details_sections_coverage_table_header_product ? billingContent?.billing_details_sections_coverage_table_header_product : "Product"}</th>
                                      <th scope="col">{billingContent?.billing_details_sections_coverage_table_header_coverage_type ? billingContent?.billing_details_sections_coverage_table_header_coverage_type : "Coverage Type"}</th>
                                      <th scope="col">{billingContent?.billing_details_sections_coverage_table_header_total_exchange ? billingContent?.billing_details_sections_coverage_table_header_total_exchange : "Total Exchange Premium"}</th>
                                      {Cookies.get('showAPTC') !== 'false' && (
                                        <th scope="col">{billingContent?.billing_details_sections_coverage_table_header_advanced_premium ? billingContent?.billing_details_sections_coverage_table_header_advanced_premium : "Advanced Premium Tax credit"}</th>
                                      )}
                                      <th scope="col">{billingContent?.billing_details_sections_coverage_table_header_monthly_charges ? billingContent?.billing_details_sections_coverage_table_header_monthly_charges : "Monthly Charges"}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {coverageSummary.length == 0 ? (
                                      <tr>
                                        <td className="fw-semibold no-data-message">{billingContent?.billing_payment_auth_nodata_text ? billingContent?.billing_payment_auth_nodata_text : "No data found"}</td>
                                        <td></td>

                                      </tr>
                                    ) : (
                                      coverageSummary?.map((item, index) => (
                                        <tr key={index}>
                                          <td>{item.cov_entity}</td>
                                          <td>{item.dependency_description}</td>
                                          <td>{item.total_exchange_premium}</td>
                                          {Cookies.get('showAPTC') !== 'false' && (
                                            <td>{item.subsidy_premium}</td>
                                          )}
                                          <td>{item.coverage_premium}</td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                                <div className="d-flex flex-wrap align-items-baseline justify-content-end gap-2 py-3 border-top">
                                  <h5 className="fw-semibold mb-0">{billingContent?.billing_details_sections_coverage_total_premiums ? billingContent?.billing_details_sections_coverage_total_premiums : "Total Coverage Premium"}</h5>
                                  <span className="fw-semibold">{coverageSummary?.[0]?.total_premium}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex col-12 mt-3">
                            <div className="col-xl-6">
                              <button
                                type="button"
                                className={`custombtn btn me-2 ${Payload?.owning_carrier === 'Q5' ? 'btn-outline-secondary' : 'btn-secondary'}`}
                                onClick={handleBack}
                              >
                                <i className='fe fe-arrow-left'></i>
                                <span className="d-inline-block ms-2">{billingContent?.billing_details_back_btn ? billingContent?.billing_details_back_btn : "Back"}</span>
                              </button>

                            </div>
                            <div className="col-xl-6 text-end">
                              {/* <button type="button" className="custombtn btn btn-back me-2">
                                <img src={printergrey}
                                  className="Print" alt="Print" />
                                <span className="d-inline-block ms-2">Print</span>
                              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main> {/*st48236 - 508 compliance*/}
    </>
  );
};
export default BillingSummary;